<template>
  <div class="up-box">
    <el-upload
      :disabled="!disabled"
      :action="actionUrl"
      list-type="picture-card"
      :on-preview="handlePictureCardPreview"
      :on-remove="onRemove"
      :on-success="onSuccess"
      :on-error="onError"
      :before-upload="beforeUpload"
      :file-list="imgUrl ? [{ url: imgUrl }] : []"
      name="uploadFile"
      :class="{ isUpload: !!imgUrl }"
    >
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-dialog :modal-append-to-body="false" v-model="dialogVisible">
      <img width="100%" :src="imgUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    accept: {
      type: String,
      default: ".jpg,.png,.gif",
    },
    imgUrl: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      actionUrl:
        this.$util.domain +
        "/adminapi/v1/basicTools/upload/one?uploadImageType=3",
      dialogVisible: false,
    };
  },
  methods: {
    handlePictureCardPreview() {
      this.dialogVisible = true;
    },
    beforeUpload(file) {
      const ext = file.name.split(".")[file.name.split(".").length - 1];
      const extList = this.$props.accept.replaceAll(".", "").split(",");
      if (!extList.includes(ext)) {
        this.$message.warning(
          `只能上传${this.$props.accept.replaceAll(".", "")}格式文件`
        );
        return false;
      }
      return true;
    },
    onSuccess(response, file, fileList) {
      if (response.error !== 10000) {
        this.$message.error("上传失败");
      } else {
        this.$emit("update:imgUrl", response.data);
      }
    },
    onError(response) {
      if (response.status === 403) {
        this.SIGNOUT();
        location.href = "/#";
      }
      this.$message.error("上传失败");
    },
    onRemove() {
      this.$emit("update:imgUrl", "");
    },
  },
};
</script>
<style scoped>
.up-box {
  display: flex;
}
.up-box img {
  width: 360px;
  height: 180px;
  margin-left: 20px;
  /* object-fit: contain; */
}
</style>
<style>
.isUpload .el-upload--picture-card {
  display: none;
}
</style>


// WEBPACK FOOTER //
// UploadImg.vue?5d8babc8